export default __webpack_public_path__ + "static/media/infoIcon.1e9109d8.svg";